module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1524-2ac76bfb14c4cdeb6b13df5bfdb03aae.png";